import SoundCardHome from './SoundCardHome';
import theme from './SoundCardHomePage.scss';

const SoundCardHomePage = (props) => {
  return <SoundCardHome {...props} theme={theme} />;
};

export default SoundCardHomePage;
